import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsContent } from '@icms/core/content';
import { BreadcrumbsComponent } from '../../../../meta/breadcrumbs.component';
import { Product } from '../../../product.decorator';
import { ProductReviewsSummaryComponent } from '../../../reviews-summary/product-reviews-summary.component';
import { NProductViewLayout } from '../../layout/product-view-layout.namespace';
import { ProductViewWishlistToggleComponent } from '../../wishlist-toggle/product-view-wishlist-toggle.component';

@Component({
    imports: [ProductReviewsSummaryComponent, BreadcrumbsComponent, TranslationModule, ProductViewWishlistToggleComponent],
    selector: 'product-view-details-name',
    templateUrl: 'product-view-details-name.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewDetailsNameComponent extends UiComponent {
    @Input()
    product?: Product<IProductDataV3>;

    @Input()
    @ICmsContent({
        watchDepth: 2
    })
    content?: NProductViewLayout.IBlockDataContent;

    protected get isSM(): boolean {
        return this.client.sizeId < 2;
    }

    protected get sku(): string | undefined {
        return this.product?.data?.sku;
    }
}
